import ImageMsg from '@/components/ImageMsg';

const GlobalComponentPlugin = {
    install(Vue) {
        Vue.component('ImageMsg', ImageMsg);
    }
}

export default GlobalComponentPlugin